import { render } from "./UP_Videos.vue?vue&type=template&id=ff7d0680"
import script from "./UP_Videos.vue?vue&type=script&lang=js"
export * from "./UP_Videos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__